import { render, staticRenderFns } from "./PinnedRuleBtn.vue?vue&type=template&id=684150df"
import script from "./PinnedRuleBtn.vue?vue&type=script&lang=js"
export * from "./PinnedRuleBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports